/**
 * Workspace DTO
 */
export interface WorkspaceDTO {
  id: number;
  name: string;
  slug: string;
  settings: Record<string, unknown> | null;
  createdAt: string;
  isAccessBlocked: boolean;
  blockedAt: string | null;
}

/**
 * Workspace Repository Interface
 */
export interface IWorkspaceRepository {
  getById(id: number): Promise<WorkspaceDTO | null>;
  getBySlug(slug: string): Promise<WorkspaceDTO | null>;
}

/**
 * Get Workspace Use Case
 *
 * Retrieves workspace information by ID or slug
 */
export class GetWorkspaceUseCase {
  constructor(private repository: IWorkspaceRepository) {}

  /**
   * Get workspace by ID
   */
  async execute(id: number): Promise<WorkspaceDTO | null> {
    return await this.repository.getById(id);
  }

  /**
   * Get workspace by slug
   */
  async getBySlug(slug: string): Promise<WorkspaceDTO | null> {
    return await this.repository.getBySlug(slug);
  }
}
